// /opt/isp_erp/frontend/src/layout/Sidebar.jsx
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { getUser } from "../store/auth.store";
// imports MIKTROTIK
import RouterIcon from '@mui/icons-material/Router';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PoolIcon from '@mui/icons-material/Pool';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
// 🆕 Imports para módulo Bodega
import WarehouseIcon from '@mui/icons-material/Warehouse';
import InventoryIcon from '@mui/icons-material/Inventory';
import DevicesIcon from '@mui/icons-material/Devices';
import HistoryIcon from '@mui/icons-material/History';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import BuildIcon from '@mui/icons-material/Build';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CategoryIcon from '@mui/icons-material/Category';
// Imports para Dashboard y Calendario
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// Import para Asignar Sucursal
import BusinessIcon from '@mui/icons-material/Business';
// 🆕 Imports para módulo FTTH
import MapIcon from '@mui/icons-material/Map';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HubIcon from '@mui/icons-material/Hub';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// DISCO
import StorageIcon from '@mui/icons-material/Storage';
// BACKUP
import BackupIcon from '@mui/icons-material/Backup';
// CALL CENTER
import PhoneIcon from '@mui/icons-material/Phone';
import HeadsetIcon from '@mui/icons-material/Headset';

// ============================================================
// 📌 CONFIGURACIÓN DE PERMISOS POR ROL
// ============================================================
const PERMISOS_MODULOS = {
  admin: {
    modulos: [
      'dashboard',
      'clientes',
      'finanzas',
      'mikrotik',
      'tickets',
      'callcenter',
      'bodega',
      'ftth',
      'servicios',
      'olts',
      'olt-status',
      'onu-administracion',
      'estadisticas',
      'sistema',
      'usuarios',
      'roles'
    ]
  },
  supervisor: {
    modulos: [
      'dashboard',
      'clientes',
      'instalaciones',
      'finanzas',
      'mikrotik',
      'tickets',
      'callcenter',
      'bodega',
      'ftth',
      'servicios',
      'olts',
      'olt-status',
      'onu-administracion',
      'estadisticas'
    ]
  },
  finanzas: {
    modulos: [
      'dashboard',
      'clientes',
      'finanzas',
      'servicios'
    ]
  },
  Recaudacion: {
    modulos: [
      'dashboard',
      'clientes',
      'instalaciones',
      'tickets',
      'callcenter',
      'finanzas'
    ]
  },
  soporte_n1: {
    modulos: [
      'dashboard',
      'clientes',
      'mikrotik',
      'instalaciones',
      'tickets',
      'ftth',
      'callcenter',
      'servicios'
    ]
  },
  soporte_n2: {
    modulos: [
      'dashboard',
      'clientes',
      'mikrotik',
      'instalaciones',
      'tickets',
      'ftth',
      'callcenter',
      'mikrotik',
      'servicios'
    ]
  },
  tecnico_campo: {
    modulos: [
      'dashboard',
      'clientes',
      'instalaciones',
      'tickets'
    ]
  },
  bodeguero: {
    modulos: [
      'dashboard',    // ✅ Dashboard
      'tickets',      // ✅ Tickets
      'bodega'        // ✅ Bodega
    ]
  }
};

// Función para verificar si el usuario tiene acceso a un módulo
const tieneAcceso = (user, modulo) => {
  if (!user || !user.roles) return false;

  // Si es admin, tiene acceso a todo
  if (user.roles.includes('admin')) return true;

  // Verificar cada rol del usuario
  for (const rol of user.roles) {
    const permisos = PERMISOS_MODULOS[rol];
    if (permisos && permisos.modulos.includes(modulo)) {
      return true;
    }
  }
  return false;
};

export default function Sidebar() {
  const user = getUser();
  const [openMenus, setOpenMenus] = useState({
    clientes: false,
    finanzas: false,
    mikrotik: false,
    tickets: false,
    bodega: false,
    ftth: false,
    disk: false,
  });

  // 🔍 DEPURACIÓN: Ver qué roles tiene el usuario
  console.log("🧑‍💻 Usuario en Sidebar:", user);
  console.log("📋 Roles del usuario:", user?.roles);

  const isAdmin = user?.roles?.includes("admin");

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  // Función para verificar si el usuario puede ver un módulo
  const puedeVer = (modulo) => {
    const acceso = tieneAcceso(user, modulo);
    console.log(`📌 Módulo "${modulo}": ${acceso ? '✅ ACCESO' : '❌ SIN ACCESO'}`);
    return acceso;
  };

  // Definir todos los items del menú con su clave de módulo
  const menuItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
      modulo: "dashboard"
    },

    {
      label: "Clientes",
      key: "clientes",
      icon: null,
      modulo: "clientes",
      subMenu: [
        { path: "/clientes/usuarios", label: "Usuarios", modulo: "clientes" },
        { path: "/clientes/mapa", label: "Mapa clientes", modulo: "clientes" },
        { path: "/clientes/instalaciones", label: "Instalaciones", modulo: "instalaciones" },
        { path: "/clientes/contratos", label: "Contratos", modulo: "clientes" },
      ],
    },

    {
      label: "Finanzas",
      key: "finanzas",
      icon: null,
      modulo: "finanzas",
      subMenu: [
        { path: "/finanzas/facturas", label: "📄 Facturas", modulo: "finanzas" },
        { path: "/finanzas/pagos", label: "💰 Pagos", modulo: "finanzas" },
        { path: "/finanzas/promesas", label: "🤝 Promesas de Pago", modulo: "finanzas" },
        { path: "/finanzas/reportes", label: "📊 Reportes", modulo: "finanzas" },
        { path: "/finanzas/dashboard", label: "📈 Dashboard Financiero", modulo: "finanzas" },
        { path: "/finanzas/sucursales", label: "🏢 Sucursales", modulo: "finanzas" },
        { path: "/finanzas/reportes-financieros", label: "📉 Reportes Financieros", modulo: "finanzas" },
        { path: "/finanzas/cuentas-bancarias", label: "🏦 Cuentas Bancarias", modulo: "finanzas" },
        { path: "/finanzas/puntos-cobro", label: "📍 Puntos de Cobro", modulo: "finanzas" }
      ],
    },

    {
      label: "MikroTik",
      key: "mikrotik",
      icon: <RouterIcon />,
      modulo: "mikrotik",
      subMenu: [
        { path: "/mikrotiks", label: "Dispositivos", icon: <SettingsEthernetIcon />, modulo: "mikrotik" },
        { path: "/mikrotik/pools", label: "Pools IP", icon: <PoolIcon />, modulo: "mikrotik" },
        { path: "/mikrotik/address-lists", label: "Address Lists", icon: <ListAltIcon />, modulo: "mikrotik" },
        { path: "/mikrotiks/gestion", label: "🏢 Asignar Sucursal", icon: <BusinessIcon />, modulo: "mikrotik" },
      ],
    },

    {
      label: "Tickets",
      key: "tickets",
      icon: <ConfirmationNumberIcon />,
      modulo: "tickets",
      subMenu: [
        { path: "/tickets", label: "📋 Listado de Tickets", modulo: "tickets" },
        { path: "/tickets/stats", label: "📊 Estadísticas", modulo: "tickets" },
        { path: "/sla-config", label: "⚙️ Configuración SLA", modulo: "tickets" },
        { path: "/tickets/calendario", label: "📅 Calendario de Trabajos", modulo: "tickets" },
        { path: "/call-center", label: "📞 Call Center", modulo: "callcenter" },
      ],
    },

    {
      label: "Bodega",
      key: "bodega",
      icon: <WarehouseIcon />,
      modulo: "bodega",
      subMenu: [
        { path: "/warehouse", label: "Dashboard Bodega", icon: <DashboardIcon />, modulo: "bodega" },
        { path: "/warehouse/inventory", label: "Inventario", icon: <InventoryIcon />, modulo: "bodega" },
        { path: "/warehouse/equipos", label: "Equipos", icon: <DevicesIcon />, modulo: "bodega" },
        { path: "/warehouse/materiales", label: "Materiales", icon: <CategoryIcon />, modulo: "bodega" },
        { path: "/warehouse/movimientos", label: "Historial Movimientos", icon: <HistoryIcon />, modulo: "bodega" },
        { path: "/warehouse/pendientes", label: "Pendientes Devolución", icon: <PendingActionsIcon />, modulo: "bodega" },
        { path: "/warehouse/rma", label: "RMA / Bajas", icon: <BuildIcon />, modulo: "bodega" },
        { path: "/warehouse/nuevo", label: "Registrar Equipo", icon: <AddCircleIcon />, modulo: "bodega" },
      ],
    },

    {
      label: "FTTH - Red Fibra",
      key: "ftth",
      icon: <AccountTreeIcon />,
      modulo: "ftth",
      subMenu: [
        { path: "/ftth/naps", label: "Mapa de NAPs", icon: <MapIcon />, modulo: "ftth" },
        { path: "/ftth/naps/lista", label: "Lista de NAPs", icon: <HubIcon />, modulo: "ftth" },
        { path: "/ftth/naps/nuevo", label: "Agregar NAP", icon: <AddCircleIcon />, modulo: "ftth" },
        { path: "/ftth/reportes", label: "Reportes FTTH", icon: <AssessmentIcon />, modulo: "ftth" },
        { path: "/ftth/red", label: "Topología Red", icon: <SettingsInputComponentIcon />, modulo: "ftth" },
      ],
    },

    {
      path: "/servicios",
      label: "📋 Servicios",
      modulo: "servicios"
    },
    {
      path: "/olts",
      label: "OLTs",
      modulo: "olts"
    },
    {
      path: "/olt-status",
      label: "OLT Status",
      modulo: "olt-status"
    },
    {
      path: "/onu-administracion",
      label: "📦 ONU Administración",
      modulo: "onu-administracion"
    },
    {
      path: "/estadisticas",
      label: "Estadísticas",
      modulo: "estadisticas"
    },

    // Módulo Sistema - solo admin
    {
      label: "🔧 Sistema",
      key: "disk",
      icon: <StorageIcon />,
      modulo: "sistema",
      subMenu: [
        { path: "/disk", label: "💾 Gestión de Disco", icon: <StorageIcon />, modulo: "sistema" },
        { path: "/backup", label: "📦 Gestión de Backups", icon: <BackupIcon />, modulo: "sistema" },
      ],
    },

    // Usuarios y Roles - solo admin
    {
      path: "/usuarios",
      label: "Usuarios",
      modulo: "usuarios"
    },
    {
      path: "/roles",
      label: "Roles",
      modulo: "roles"
    },
  ];

  // Filtrar items del menú según permisos
  const itemsFiltrados = menuItems.filter(item => {
    // Verificar si el usuario puede ver este módulo
    const acceso = puedeVer(item.modulo);
    return acceso;
  });

  console.log("📊 Items filtrados:", itemsFiltrados.length, "de", menuItems.length);

  return (
    <aside style={styles.sidebar}>
      <h3 style={styles.title}>ERP MENU</h3>
      {itemsFiltrados.map((item, idx) =>
        item.subMenu ? (
          <div key={idx} style={{ marginBottom: 8 }}>
            <span
              style={styles.menuHeader}
              onClick={() => toggleMenu(item.key)}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {item.icon && <span style={{ fontSize: 18 }}>{item.icon}</span>}
                {item.label}
              </span>
              <span style={{ fontSize: 12 }}>{openMenus[item.key] ? "▼" : "▶"}</span>
            </span>
            {openMenus[item.key] && (
              <div style={styles.subMenu}>
                {item.subMenu.map((sub) => {
                  // Verificar si el usuario puede ver este sub-item específico
                  if (!puedeVer(sub.modulo)) return null;
                  return (
                    <NavLink
                      key={sub.path}
                      to={sub.path}
                      style={({ isActive }) =>
                        isActive ? { ...styles.link, ...styles.active } : styles.link
                      }
                      title={sub.description}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {sub.icon && <span style={{ fontSize: 16 }}>{sub.icon}</span>}
                        {sub.label}
                      </span>
                    </NavLink>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <NavLink
            key={item.path}
            to={item.path}
            style={({ isActive }) =>
              isActive ? { ...styles.link, ...styles.active } : styles.link
            }
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {item.icon && <span style={{ fontSize: 18 }}>{item.icon}</span>}
              {item.label}
            </span>
          </NavLink>
        )
      )}
    </aside>
  );
}

const styles = {
  sidebar: {
    width: 260,
    backgroundColor: "#1e293b",
    color: "#fff",
    height: "100vh",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    overflowY: "auto",
    position: "sticky",
    top: 0,
  },
  title: {
    marginBottom: "12px",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#fff",
    borderBottom: "1px solid #334155",
    paddingBottom: "12px",
  },
  menuHeader: {
    color: "#94a3b8",
    fontWeight: "bold",
    marginTop: "12px",
    marginBottom: "4px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    padding: "8px 4px",
    borderRadius: "4px",
    transition: "background-color 0.2s",
  },
  subMenu: {
    marginLeft: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  link: {
    color: "#cbd5e1",
    textDecoration: "none",
    padding: "8px 12px",
    borderRadius: "4px",
    fontSize: "14px",
    transition: "all 0.2s",
    display: "block",
    marginBottom: "2px",
  },
  active: {
    backgroundColor: "#0f172a",
    color: "#fff",
    fontWeight: "bold",
    borderLeft: "3px solid #3b82f6",
  },
};
